export const FETCH_ALLMEDIUM_REQUEST = 'FETCH_ALLMEDIUM_REQUEST'
export const FETCH_ALLMEDIUM_SUCCESS = 'FETCH_ALLMEDIUM_SUCCESS'
export const FETCH_ALLMEDIUM_FALIURE = 'FETCH_ALLMEDIUM_FALIURE'
